// extracted by mini-css-extract-plugin
export default {"form":"AssignmentSubmit_form__CaE47","info-message":"AssignmentSubmit_info-message__-szt8","buttons":"AssignmentSubmit_buttons__mcbWb"};